var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BusinessOmniplayEventsSimpleCoreVue',{attrs:{"dateDimension":_vm.dateDimension,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }